import * as React from "react"
import { FaRegEnvelope, FaInstagram, FaFacebook } from "react-icons/fa"
import classes from "./Footer.module.css"

const Footer = () => {
  return (
    <footer className={classes.footerSection}>
      {/* <a
        href="mailto:tenetbeef@gmail.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaRegEnvelope className={classes.envelope} />
      </a> */}
      <div className={classes.footerContent}>
        <p className={classes.footerText}>
          Tenet® Beef is a trademark of Callipyge Genetics, LLC
        </p>
        <p className={classes.addressText}>
          433 Ames Rd, Selah, WA 98942{" "}
          <span style={{ margin: "0 5px" }}>|</span> (509) 731-4799
        </p>
        <p className={classes.socialMedia}>
          <a
            href="mailto:tenetbeef@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginRight: "15px" }}
          >
            <FaRegEnvelope style={{ fontSize: "1.25rem" }} />
          </a>
          <a
            href="https://www.facebook.com/tenetbeef"
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginRight: "15px" }}
          >
            <FaFacebook style={{ fontSize: "1.125rem" }} />
          </a>
          <a
            href="https://www.instagram.com/tenetbeef"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram style={{ fontSize: "1.25rem" }} />
          </a>
        </p>
      </div>
    </footer>
  )
}

export default Footer
